import { useState } from 'react';
import { agencyAPI } from '../../../../utilities/api';
import { Agency } from '../../../../utilities/interfaces/Agency';
import CustomDialog from '../../../../components/stateless/dialog/CustomDialog';
import TextField from '../../../../components/stateful/textField/TextField';
import { useNotificationHelper } from '../../../../utilities/helpers/NotificationHelper';

type Props = { open: boolean; closeDialog: () => void; agency: Agency };

export const AgencyEditDialog = (props: Props) => {
  const { open, closeDialog, agency } = props;
  const [agencyName, setAgencyName] = useState<string>('');
  const { addNotification } = useNotificationHelper();

  const handleAgencyNameChange = (name: string) => {
    setAgencyName(name);
  };

  const approve = async () => {
    if (!agency) {
      addNotification({
        type: 'success',
        message: `No selected agency found.`,
      });
      return;
    }
    const editAgency: Agency = {
      id: agency.id,
      agencyName: agencyName,
    };
    await agencyAPI
      .updateAgency(editAgency)
      .then(() => {
        closeDialog();
        addNotification({
          type: 'success',
          message: `${editAgency.agencyName} saved successfully.`,
        });
      })
      .catch((error: any) => {
        addNotification({
          type: 'error',
          message: `${editAgency.agencyName} was unable to save.`,
        });
      });
  };

  return (
    <>
      {open ? (
        //#region dialog
        <CustomDialog
          open={open}
          title={'Edit Agency'}
          toggleDialog={closeDialog}
          approveAction={approve}
          cancelAction={closeDialog}
        >
          <div className="code-textfield">
            <TextField
              onChange={(value: string) => {
                handleAgencyNameChange(value);
              }}
              title={'Agency Name'}
              value={agency.agencyName}
              fullwidth
            />
          </div>
        </CustomDialog>
      ) : //#endregion
      null}
    </>
  );
};
